// Yapılacaklar Listesi (/todo-list) ve görev formu. Durum ve öncelik adları
// ortak `tasks.*` metinlerinden gelir; kayıtlı görev metinleri olduğu gibi kalır.
const todo = {
  page: {
    title: 'Yapılacaklar Listesi',
    subtitle: 'Tüm görevleri görüntüleyin, durumlarını güncelleyin ve takip edin.',
  },
  actions: {
    add: 'Yeni Görev',
  },
  stats: {
    total: 'Toplam Görev',
    totalShort: 'Toplam',
    pending: 'Beklemede',
    pendingShort: 'Bekleyen',
    inProgress: 'Devam Ediyor',
    inProgressShort: 'Devam eden',
    completed: 'Tamamlandı',
    completedShort: 'Biten',
    share: 'Tüm görevlerin %{{percent}}’i',
  },
  toolbar: {
    search: 'Görev, açıklama veya kişi ara…',
    searchShort: 'Görev ara…',
    status: 'Görev durumu',
    all: 'Tümü',
    mine: 'Bana atananlar',
    mineHint: 'Yalnızca size atanmış görevler',
    overdue: 'Gecikmiş',
    overdueHint: 'Son tarihi geçmiş, açık görevler',
    sort: 'Sırala',
    sortBy: {
      createdAt: 'Oluşturulma',
      dueDate: 'Son tarih',
      priority: 'Öncelik',
      status: 'Durum',
      title: 'Görev adı',
    },
    asc: 'Artan sıra',
    desc: 'Azalan sıra',
  },
  columns: {
    title: 'Görev',
    status: 'Durum',
    priority: 'Öncelik',
    assignee: 'Atanan',
    dueDate: 'Son Tarih',
    createdAt: 'Oluşturulma',
    createdBy: 'Oluşturan',
  },
  table: {
    listLabel: 'Görev listesi',
    empty: 'Görev bulunamadı',
    rangeOf: '/ {{total}} görev',
    ofTotal: 'toplam {{total}} görev içinden',
    jump: 'Sayfaya git',
    more: '+{{count}} daha',
    overdue: 'Gecikmiş',
    changeStatus: 'Durumu değiştir',
  },
  panel: {
    label: 'Seçili görev',
    heading: 'Görev',
    edit: 'Düzenle',
    delete: 'Sil',
    description: 'Açıklama',
    noDescription: 'Açıklama eklenmemiş',
    assignees: 'Atananlar',
    statusTitle: 'Durumu Değiştir',
    readOnly: 'Durumu yalnızca görevin atandığı kişiler ve yöneticiler değiştirebilir.',
    dueDate: 'Son tarih',
    createdAt: 'Oluşturulma',
    createdBy: 'Oluşturan',
    completedAt: 'Tamamlanma',
    markDone: 'Tamamlandı Olarak İşaretle',
    reopen: 'Yeniden Aç (Beklemede)',
    reopenHint: 'Görevi yeniden "Beklemede" durumuna alır',
    priority: '{{priority}} öncelik',
    auto: 'Otomatik',
    autoHint: 'Sistem tarafından otomatik oluşturuldu',
    accounting: 'Muhasebe',
    accountingHint: 'Proje görevleri için muhasebe ekibine açılan görev; tamamlanınca grubundaki görevler de tamamlanır',
    system: 'Sistem',
  },
  form: {
    newTitle: 'Yeni Görev Oluştur',
    editTitle: 'Görevi Düzenle',
    subtitle: 'Görevi bir veya birden fazla kişiye atayın.',
    title: 'Görev başlığı',
    titlePlaceholder: 'Görev başlığını girin…',
    description: 'Açıklama',
    descriptionPlaceholder: 'Görev açıklamasını girin…',
    priority: 'Öncelik',
    status: 'Durum',
    dueDate: 'Son tarih',
    assignees: 'Atanan kişiler',
    assigneesPlaceholder: 'Kişi seçin',
    assigneeSearch: 'Çalışan ara…',
    noResults: 'Sonuç bulunamadı',
    selected_one: '{{count}} kişi seçildi',
    selected_other: '{{count}} kişi seçildi',
    remove: '{{name}} kişisini kaldır',
    accountingNote: 'Başlıkta veya açıklamada "proje" geçen yeni görevlerde muhasebe ekibine otomatik görev açılır.',
    cancel: 'İptal',
    create: 'Oluştur',
    update: 'Güncelle',
    saving: 'Kaydediliyor…',
  },
  delete: {
    title: 'Görevi Sil',
    message: '"{{title}}" görevini silmek istediğinize emin misiniz? Bu işlem geri alınamaz.',
    confirm: 'Evet, sil',
    cancel: 'Vazgeç',
  },
  toast: {
    loadError: 'Görevler yüklenirken hata oluştu',
    notFound: 'Görev bulunamadı',
    completedSynced_one: 'Görev tamamlandı ve {{count}} ilişkili muhasebe görevi otomatik olarak tamamlandı',
    completedSynced_other: 'Görev tamamlandı ve {{count}} ilişkili muhasebe görevi otomatik olarak tamamlandı',
    completed: 'Görev tamamlandı',
    statusUpdated: 'Görev durumu güncellendi',
    statusError: 'Görev durumu güncellenirken hata oluştu',
    deleted: 'Görev silindi',
    deleteError: 'Görev silinirken hata oluştu',
    titleRequired: 'Görev başlığı zorunludur',
    assigneeRequired: 'En az bir kişi atanmalıdır',
    updated: 'Görev güncellendi',
    createdWithAccounting_one: 'Görev oluşturuldu ve {{count}} muhasebe üyesine otomatik görev atandı',
    createdWithAccounting_other: 'Görev oluşturuldu ve {{count}} muhasebe üyesine otomatik görev atandı',
    created: 'Görev oluşturuldu',
    saveError: 'Görev kaydedilirken hata oluştu',
    pageJumpInvalid: 'Lütfen 1 ile {{max}} arasında bir sayfa numarası girin.',
  },
};

export default todo;
